/*
 * Copyright (C) 2026 Das Land Schleswig-Holstein vertreten durch den
 * Ministerpräsidenten des Landes Schleswig-Holstein
 * Staatskanzlei
 * Abteilung Digitalisierung und zentrales IT-Management der Landesregierung
 *
 * Lizenziert unter der EUPL, Version 1.2 oder - sobald
 * diese von der Europäischen Kommission genehmigt wurden -
 * Folgeversionen der EUPL ("Lizenz");
 * Sie dürfen dieses Werk ausschließlich gemäß
 * dieser Lizenz nutzen.
 * Eine Kopie der Lizenz finden Sie hier:
 *
 * https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12
 *
 * Sofern nicht durch anwendbare Rechtsvorschriften
 * gefordert oder in schriftlicher Form vereinbart, wird
 * die unter der Lizenz verbreitete Software "so wie sie
 * ist", OHNE JEGLICHE GEWÄHRLEISTUNG ODER BEDINGUNGEN -
 * ausdrücklich oder stillschweigend - verbreitet.
 * Die sprachspezifischen Genehmigungen und Beschränkungen
 * unter der Lizenz sind dem Lizenztext zu entnehmen.
 */
export const RoleLabels: Record<string, string> = {
  ADMIN_ADMIN: 'Admin',
  DATENBEAUFTRAGUNG: 'Datenbeauftragung',
  VERWALTUNG_LOESCHEN: 'Löschen',
  VERWALTUNG_USER: 'User',
  VERWALTUNG_POSTSTELLE: 'Poststelle',
};

export const RoleDescriptions: Record<string, string> = {
  ADMIN_ADMIN:
    'Diese Rolle kann Funktionen der OZG-Cloud konfigurieren, z.B. Benutzer anlegen, Organisationseinheiten hinzufügen und Rollen zuweisen.',
  DATENBEAUFTRAGUNG:
    'Diese Rolle kann in der Administration unter dem Menüpunkt "Auswertungen" Felder zur Auswertung konfigurieren. Sie ist mit allen anderen Rollen kompatibel.',
  VERWALTUNG_LOESCHEN:
    'Diese Rolle hat dieselben Rechte wie die Rolle "User". Zusätzlich kann "Löschen" Löschanträge aus Alfa bestätigen. ',
  VERWALTUNG_USER: 'Diese Rolle kann alle Vorgänge sehen und bearbeiten.',
  VERWALTUNG_POSTSTELLE: 'Diese Rolle kann alle neu eingegangenen Vorgänge sehen.',
};

export const TECH_USER_ROLE_NAME: string = 'TECH_USER';

export const HIDDEN_CLIENT_ROLES: Record<'admin' | 'alfa', string[]> = {
  admin: [],
  alfa: [TECH_USER_ROLE_NAME, 'ADMIN_ADMIN'],
};
